import { EngagementErrorDialogDataModel } from './engagement-error-dialog-data.model';

export class EngagementGenericErrorStrategyModel implements EngagementErrorDialogDataModel {
  engagementId: number;
  errorCode: string;
  shouldShowSupportLink: boolean;

  constructor(engagementId: number, errorCode: string) {
    this.engagementId = engagementId;
    this.errorCode = errorCode;
    this.shouldShowSupportLink = true;
  }

  getTitle = () => 'An error has occurred.';
  getMessage = () => `
    Please reload the page and try again. 
    If the problem persists contact support at <a href="mailto:support@aiwyn.ai">support@aiwyn.ai</a> and send us the error code shown below.
  `;
  getButtonText = () => 'Reload Page';
  getRoutePath = () => '';
}
